import { atom } from 'jotai';
import { StrapiShippingRate } from '../../../core/models/strapi-shipping-rate.model';

const shippingRatesAtom = atom<StrapiShippingRate[] | null>(null);

export { shippingRatesAtom };
